import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type FleetAuthenticatePeriod, type User, type Vehicle } from "../../api";

export interface ListLoginReportItemCellProps {
    readonly period: FleetAuthenticatePeriod;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListLoginReportItemCell extends React.Component<ListLoginReportItemCellProps> {
    constructor(props: ListLoginReportItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get user(): User | undefined {
        if (!this.props.period) {
            return;
        }
        return store.repositoryUsers.byId(this.props.period.userId);
    }

    @computed private get vehicle(): Vehicle | undefined {
        if (!this.props.period) {
            return;
        }
        return store.repositoryVehicles.byId(this.props.period.vehicleId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        switch (column.key) {
            case "eventId":
                return <span>LOG-{this.props.period?.eventId}</span>;
            case "userEmployeeId":
                return <span>{this.user?.employeeId}</span>;
            case "vehicleSerialNumber":
                return <span>{this.vehicle?.serialNumber}</span>;
            case "loggedInTime":
                return <span>{store.i18n.formatDateTime(this.props.period.startTime)}</span>;
            case "loggedOutTime":
                return (
                    <span>
                        {this.props.period.stopTime
                            ? store.i18n.formatDateTime(this.props.period.stopTime)
                            : ""}
                    </span>
                );
            case "loginDuration":
                return (
                    <span>
                        {this.props.period.stopTime
                            ? store.i18n.formatDuration(
                                  (this.props.period.stopTime.getTime() -
                                      this.props.period.startTime.getTime()) /
                                      1000,
                              )
                            : ""}
                    </span>
                );
            case "logoutType":
                return (
                    <span>
                        {this.props.period.logoutType
                            ? store.i18n.formatLogoutType(this.props.period.logoutType)
                            : ""}
                    </span>
                );
            default:
                return <></>;
        }
    }
}
